/* eslint-disable no-unused-vars */
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import Home from '../pages/main/Home';
import NextSession from '../pages/main/NextSession';
import CoursesList from '../pages/main/CoursesList';
import CourseDetails from '../pages/main/CourseDetails';
import SessionDetails from '../pages/main/SessionDetails';
import InterviewQuestions from '../pages/main/InterviewQuestions';
import ComingSoon from '../components/Coming-soon/ComingSoon';
import Faq from '../pages/main/FAQ';
import ContactUs from '../pages/main/ContactUs';
import Support from '../pages/main/Support';
import Feedback from '../pages/main/Feedback';
import Testimonial from '../pages/main/Testimonial';
import CompaniesStudentsWorked from '../pages/main/CompaniesStudentsWorked';
import Error404 from '../pages/main/Error404';
import routesPath from './routesPath';
import TermsOfUse from '../pages/main/TermsOfUse';
import LaptopTools from '../pages/main/LaptopTools'
import AvailablesCourse from '../pages/main/AvailablesCourses';

const Routes = [
    {
        component: <Home />,
        path: routesPath.home,
        meta: {},
    },
    {
        component: <NextSession />,
        path: routesPath.nextSession,
        meta: {},
    },
    // {
    //     component: <CoursesList/>,                                                                                               
    //     path: routesPath.courses,
    //     meta: {},
    // },
    {
        component: <CourseDetails />,
        path: routesPath.courseDetails,
        meta: {},
    },
    {
        component: <SessionDetails />,
        path: routesPath.sessionsDetails,
        meta: {},
    },
    {
        component: <InterviewQuestions />,
        path: routesPath.interviewquestions,
        meta: {},
    },
    // {
    //     component: <ComingSoon/>,                                                                                               
    //     path: routesPath.ComingSoon,
    //     meta: {},
    // },
    // {
    //     component: <Support/>,                                                                                               
    //     path: routesPath.Support,
    //     meta: {},
    // },
    {
        component: <ContactUs />,
        path: routesPath.contactUs,
        meta: {},
    },
    {
        component: <CompaniesStudentsWorked />,
        path: routesPath.CompaniesStudentsWorked,
        meta: {},

    },
    // {
    //     component: <Error404/>,                                                                                               
    //     path: routesPath.error404,
    //     meta: {},
    // },
    {
        component: <Faq />,
        path: routesPath.faq,
        meta: {},
    },
    {
        component: <Testimonial />,
        path: routesPath.testimonials,
        meta: {},
    },
    {
        component: <Feedback />,
        path: routesPath.feedback,
        meta: {},
    },

    {
        component: <AvailablesCourse />,
        path: routesPath.availablesCourses,
        meta: {},
    },

    {
        component: <TermsOfUse />,
        path: routesPath.termsOfUse,
        meta: {},
    },
    {
        component: <LaptopTools />,
        path: routesPath.laptopTools,
        meta: {},
    },

]

export default Routes

